const GetUsers = 'UserManagement/GetUsers'
const GetUserRoles = 'UserManagement/GetUserRoles'
const SaveUserRoles = 'UserManagement/SaveUserRoles'
const GetAllRoles = "UserManagement/GetAllRoles"
const GetVessels = "Vessels/GetVessels"
const GetUsersDetailsByEmail = 'DPPContactManagement/GetUsersDetailsByEmail'
const GetVesselInspections = 'Vessels/GetVesselInspections'
const GetInspectionDetentionStatistics = 'Vessels/GetInspectionDetentionStatistics'
const GetCompanyDetailsByName = "Company/GetCompanyByName"
const GetVesselStatistics = "Vessels/GetVesselStatistics"
const GetArrivals = "Vessels/GetArrivals"
const GetUpcomingFSInspections = "Vessels/GetUpcomingFSInspections"
export const ApiUrls = {
  GetUsers,
  GetUserRoles,
  SaveUserRoles,
  GetAllRoles,
  GetVessels,
  GetUsersDetailsByEmail,
  GetVesselInspections,
  GetInspectionDetentionStatistics,
  GetCompanyDetailsByName,
  GetVesselStatistics,
  GetArrivals,
  GetUpcomingFSInspections
}